import { appstr } from "../utils/appstr";
import {
  enumChartOpenModes,
  enumFolderStatus,
  enumSCArrowVariants,
  enumUIModes,
  appRoutes,
  gCUIFont,
  gUIFont,
  kAccountActive,
  kAccountDisabled,
  kAccountEnterprise,
  kAccountExpired,
  kAccountTrial,
  kAccountTrialExpired,
  kROUser
} from "../constants";
import { uFramelessPanelColor } from "../whitelabel/brand";
import { ValidDate } from "../utils/ValidDate";
import { Globals } from "./Globals";

/**
 * @typedef {Object} BoxStyleDefaults
 * @property {string=} brandingFill
 * @property {string=} brandingBorder
 */

export class QOrgInfo {
  constructor() {
    this.fWSMgr = null;
    this.fAccountName = null;
    this.fOrgName = null;
    this.fSCArrowStyle = null;
    this.fSeatCount = null;
    this.fBoxCount = null;
    this.fPointInTimeActivated = false;
    this.fPlanningActivated = false;
    this.fReportingActivated = false;
    this.fAllowedBoxCount = null;
    this.fEdition = null;
    this.fCustomColors = null;
    this.fUseMetric = null;
    this.fGracePeriod = null;
    this.fForceResetPass = null;
    this.fSMSPass = null;
    this.fExpireDate = "9999-01-01";
    this.fDateFormat = null;
    this.fTimeFormat = null;

    this.fOpenDoc = false;
    this.fOpenDocDir = null;
    this.fOpenDocName = null;
    this.fUIColor = null;
    this.fButtonColor = null;
    this.fCurrentUIFont = "";
    this.fCustomUIFont = "";

    this.fDocuments = null;
    this.fLaunchMode = null;
    this.fBoxStyleDefaults = {};
    this.fOnboardingNeeded = false;
  }

  InitOrgInfo(wsMgr) {
    this.fWSMgr = wsMgr;
    this.fAccountName = "unknown"; //orgid
    this.fOrgName = "<" + appstr("companyname") + ">";
    this.fSCArrowStyle = enumSCArrowVariants.miniarrow;
    this.fBoxCount = 500;
    this.fSeatCount = 1;
    this.fEdition = kAccountEnterprise;
    this.fCustomColors = [];
    this.fUseMetric = 0;
    this.fComplexPass = 0;
    this.fForceResetPass = 0;

    this.fSMSPass = 0;
    this.fDateFormat = 0;
    this.fTimeFormat = 24; //or 12

    this.fOpenDoc = false;
    this.fOpenDocDir = "-";
    this.fOpenDocName = "-";
    this.fLaunchMode = "Workbench"; //Legacy Compatability

    this.fHelp1 = "";
    this.fHelp2 = "";
    this.fCustomFonts = "";
    this.fBoxStyleDefaults = {};

    this.fUIColor = uFramelessPanelColor;
    this.fButtonColor = "White";
    this.fCurrentUIFont = "";
    this.fCustomUIFont = "";
    this.fOnboardingNeeded = false;
  }

  /**
   * @param {BoxStyleDefaults=} boxStyleDefaults
   */
  SetBoxStyleDefaults(boxStyleDefaults) {
    this.fBoxStyleDefaults = boxStyleDefaults;
  }

  SetOnboardingNeeded(onboardingNeeded) {
    this.fOnboardingNeeded = onboardingNeeded === true;
  }

  GetOnboardingNeeded() {
    return this.fOnboardingNeeded === true;
  }

  /**
   * @returns {BoxStyleDefaults}
   */
  GetBoxStyleDefaults() {
    return this.fBoxStyleDefaults;
  }
  GetCustomColors() {
    return this.fCustomColors;
  }

  SetCustomColors(colorList) {
    this.fCustomColors = colorList;
  }

  GetLaunchMode() {
    return this.fLaunchMode;
  }

  SetLaunchMode(mode) {
    this.fLaunchMode = mode;
  }

  GetOrgName() {
    return this.fOrgName;
  }

  SetOrgName(newName) {
    this.fOrgName = newName;
  }

  GetSCArrowStyle() {
    return this.fSCArrowStyle;
  }

  SetSCArrowStyle(arrowStyle) {
    this.fSCArrowStyle = arrowStyle;
  }

  GetUseMetric() {
    return this.fUseMetric;
  }

  SetUseMetric(useMetric) {
    this.fUseMetric = useMetric;
  }

  GetForceResetPass() {
    return this.fForceResetPass;
  }

  SetForceResetPass(resetPass) {
    this.fForceResetPass = resetPass;
  }

  GetSMSPass() {
    return this.fSMSPass;
  }

  SetSMSPass(smsPass) {
    this.fSMSPass = smsPass;
  }

  GetDateFormat() {
    return this.fDateFormat;
  }

  SetConnectorToggleList(toggleList) {
    this.fConnectorToggleList = toggleList;
  }

  GetConnectorToggleList() {
    return this.fConnectorToggleList;
  }

  SetFontFace(fontFace) {
    this.fCurrentUIFont = fontFace;
    //gUIFont = fontFace;
    //if (kFontViewerOptions.indexOf(fontFace) < 0) {
    //  this.fCustomUIFont = fontFace;
    // }
  }

  AddCustomFontToList(curCustomFontFace) {
    var fontFaceList = []; //kFontViewerOptions;
    this.fCustomUIFont = curCustomFontFace;
    //gCUIFont = curCustomFontFace;
    if (fontFaceList.indexOf(curCustomFontFace) > -1 && curCustomFontFace !== "") {
      fontFaceList.push(curCustomFontFace);
    }
  }

  SetDateFormat(dateFormat) {
    this.fDateFormat = dateFormat;
  }

  GetTimeFormat() {
    return this.fTimeFormat;
  }

  SetTimeFormat(timeFormat) {
    this.fTimeFormat = timeFormat;
  }

  GetSeatCount() {
    return this.fSeatCount;
  }

  SetSeatCount(seatCount) {
    this.fSeatCount = seatCount;
  }

  GetAllowedBoxCount() {
    return this.fAllowedBoxCount;
  }

  SetAllowedBoxCount(aBoxCount) {
    this.fAllowedBoxCount = aBoxCount;
  }

  GetBoxCount() {
    return this.fBoxCount;
  }

  GetPointInTime() {
    return this.fPointInTimeActivated;
  }

  SetBoxCount(boxCount) {
    this.fBoxCount = parseInt(boxCount);
  }

  GetExpireDate() {
    return this.fExpireDate;
  }

  SetExpireDate(expireDate) {
    this.fExpireDate = expireDate;
  }

  GetGracePeriod() {
    return this.fGracePeriod;
  }

  SetGracePeriod(gracePeriod) {
    this.fGracePeriod = gracePeriod;
  }

  GetOpenDoc() {
    return this.fOpenDoc;
  }

  SetOpenDoc(openDoc) {
    this.fOpenDoc = openDoc;
  }

  GetOpenDocDir() {
    return this.fOpenDocDir;
  }

  SetOpenDocDir(docDir) {
    this.fOpenDocDir = docDir;
  }

  GetOpenDocName() {
    return this.fOpenDocName;
  }

  SetOpenDocName(docName) {
    this.fOpenDocName = docName;
  }

  GetCustomHelp1() {
    return this.fHelp1;
  }

  GetCustomFonts() {
    //return "Steve, Fred, Harry ";
    return this.fCustomFonts;
  }

  GetCustomHelp2() {
    return this.fHelp2;
  }

  SetDocumentList(docList) {
    this.fDocuments = docList;
  }

  GetDocumentList() {
    return this.fDocuments;
  }

  SetMasterChartList(chartList) {
    this.fMasterChartList = chartList;
  }

  GetMasterChartList() {
    return this.fMasterChartList;
  }

  GetCurrentBaseChart(doc, chartList) {
    for (let achart in chartList) {
      if (chartList[achart]["ID"] == doc.GetChartID()) return chartList[achart];
    }
    return null;
  }

  SetAppendTableList(appendTables) {
    this.fAppendTables = appendTables;
  }

  GetAppendTableList() {
    return this.fAppendTables;
  }

  GetAppendTableByID(appendID) {
    for (var i = 0; i < this.fAppendTables.length; i++) {
      var aTable = this.fAppendTables[i];
      if (aTable["ID"] == appendID) return aTable;
    }
    return null;
  }

  HandleViewerLaunchChartDocFallback(userInfo, accessGroup) {
    var allowedChartDocList = this.fWSMgr.GetAllowedDocuments();
    var allowedMasterChartList = this.fWSMgr.GetAllowedCharts();
    var openMode = Globals._uiConfig.GetChartOpenMode();

    // If launch to viewer, check user has chart access and attempt chart doc fallback if necessary.
    if (
      (openMode === enumChartOpenModes.masterchart && allowedMasterChartList.length === 0) ||
      openMode === enumChartOpenModes.opendoc
    ) {
      // Now we will verify launch chart doc access (chart doc launch) OR proceed to fallback from launch master chart to chart doc (master chart launch and no master charts available).
      if (allowedChartDocList.length > 0) {
        Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.opendoc);
        var launchDoc = Globals._uiConfig.GetDocConfig();
        var groupID = userInfo.GetUserGroupID();
        // check if launch doc allowed by group to allow for master chart fallback
        if (
          launchDoc != null &&
          groupID != "0" &&
          accessGroup.FolderInGroup(launchDoc["dir"]) === enumFolderStatus.notingroup
        )
          launchDoc = null;
        // if master charts available general fallback to master chart otherwise fallback to first available chart doc.
        if (launchDoc == null) {
          // fallback to chart doc if no masters available
          if (allowedMasterChartList.length === 0) {
            var fallbackLaunchDoc = allowedChartDocList[0];
            Globals._uiConfig.SetDocConfig(
              fallbackLaunchDoc["directory"],
              fallbackLaunchDoc["filename"]
            );
          }
          // general default back to master if launch chart doc was restricted
          else {
            Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
          }
        }
      }
    }

    // TODO: This should be enforced within DoWorkbenchMode
    if (
      Globals._uiConfig.GetUIMode() === enumUIModes.edit &&
      Globals._accountInfo.GetUserRole() === kROUser
    ) {
      if (this.fWSMgr.routerNavigate) {
        this.fWSMgr.routerNavigate(appRoutes.chart);
      }
    }
  }

  isValidAccountDate(status) {
    var expireDate = this.GetExpireDate();
    // Valid date format is yyyy/mm/dd
    if (!ValidDate(expireDate)) return false;

    var isExpired = this.TestExpired();
    var isActiveAcct =
      [kAccountActive, kAccountTrial].includes(status) ||
      (!isExpired &&
        [kAccountTrialExpired, kAccountExpired].includes(status) &&
        this.TestExpired(0));
    var isDisabled = kAccountDisabled == status;

    return (!isExpired && isActiveAcct) || (isExpired && !isActiveAcct) || isDisabled;
  }

  TestExpired(overrideGracePeriod) {
    var d = new Date();

    var expireDate = this.GetExpireDate();
    if (expireDate == null) return false;

    var exp_d = new Date(expireDate);

    var theGracePeriod =
      overrideGracePeriod == null ? parseInt(this.GetGracePeriod()) : overrideGracePeriod;
    if (theGracePeriod) {
      exp_d.setDate(exp_d.getDate() + theGracePeriod);
    }

    var isValid = ValidDate(exp_d);
    if (!isValid) return true;

    var expireyear = exp_d.getFullYear();
    var expiremonth = exp_d.getMonth() + 1;
    var expireday = exp_d.getDate();

    var curyear = d.getFullYear();
    if (curyear > expireyear) return true;
    if (curyear == expireyear) {
      var curmonth = d.getMonth() + 1;
      if (curmonth > expiremonth) return true;
      if (curmonth == expiremonth) {
        var curday = d.getDate();
        if (curday > expireday) return true;
      }
    }

    return false;
  }
}
